const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1A_signin_local_and_azure_ad",
        forgotPassword: "B2C_1A_PasswordReset",
        editProfile: "b2c_1a_DOES_NOT_EXIST"
    },
    authorities: {
        signUpSignIn: {
            authority: "https://cocreateb2c.b2clogin.com/cocreateb2c.onmicrosoft.com/B2C_1A_signin_local_and_azure_ad",
        },
        forgotPassword: {
            authority: "https://cocreateb2c.b2clogin.com/cocreateb2c.onmicrosoft.com/B2C_1A_PasswordReset",
        },
        editProfile: {
            authority: ""
        }
    }
}

const apiConfig = {
    b2cScopes: ["https://cocreateb2c.onmicrosoft.com/ccapi/demo.read"],
    webApi: "https://cc.engageworks.com/api/v1/status/probe"
}

export default {
    api: {
        url: 'https://cc.engageworks.com:443'
    },

    //msal configs
    msalConfig: {
        auth: {
            clientId: "a5f19dcb-601d-4b98-af23-2f1fbb301b33",
            authority: b2cPolicies.authorities.signUpSignIn.authority,
            validateAuthority: false,
            redirectUri: "https://ccadmin.engageworks.com/",
            postLogoutRedirectUri: "https://ccadmin.engageworks.com/"
        },
        cache: {
            cacheLocation: "sessionStorage",
            storeAuthStateInCookie: true
        }
    },
    loginRequest: {
        scopes: ["openid", "profile"],
    },
    tokenRequest: {
        scopes: apiConfig.b2cScopes
    },
    forgotPasswordAuthority: "https://cocreateb2c.b2clogin.com/cocreateb2c.onmicrosoft.com/B2C_1A_PasswordReset"
}
